import forexFutures from '../../../constants/forexFuturesConstants';

export const detectLiquiditySweeps = (currencyPair, data, gapThreshold, dateRange) => {
  const liquiditySweeps = [];

  // Retrieve tick size and value for the given currency pair
  const forexData = forexFutures[currencyPair];
  const tickSize = forexData?.tickSize || null;
  const tickValue = forexData?.tickValue || null;

  if (!forexData) {
    console.warn(`Tick size or value is not defined for currency pair: ${currencyPair}`);
  }

  const startDate = dateRange?.start ? new Date(dateRange.start).getTime() : null;
  const endDate = dateRange?.end ? new Date(dateRange.end).getTime() : null;

  for (let i = 1; i < data.length - 1; i++) {
    const prevCandle = data[i - 1];
    const currentCandle = data[i];
    const nextCandle = data[i + 1];

    // Filter by date range
    const currentTime = new Date(currentCandle.time).getTime();
    if ((startDate && currentTime < startDate) || (endDate && currentTime > endDate)) {
      continue; // Skip candles outside the range
    }

    // Check for a bullish liquidity sweep (price breaches a low and closes higher)
    if (currentCandle.low < prevCandle.low && currentCandle.close > prevCandle.low) {
      const breachLevel = prevCandle.low;
      const reversalClose = currentCandle.close;
      const difference = parseFloat((breachLevel - reversalClose).toFixed(4));

      let potentialGain = "No value found";
      if (tickSize && tickValue) {
        const gainInTicks = Math.floor(difference / tickSize);
        potentialGain = gainInTicks * tickValue;
      }

      if (Math.abs(difference) >= gapThreshold) {
        liquiditySweeps.push({
          time: currentCandle.time,
          breachLevel,
          reversalClose,
          direction: "bullish",
          difference,
          potentialGain,
        });
      }
    }

    // Check for a bearish liquidity sweep (price breaches a high and closes lower)
    if (currentCandle.high > prevCandle.high && currentCandle.close < prevCandle.high) {
      const breachLevel = prevCandle.high;
      const reversalClose = currentCandle.close;
      const difference = parseFloat((breachLevel - reversalClose).toFixed(4));

      let potentialGain = "No value found";
      if (tickSize && tickValue) {
        const gainInTicks = Math.floor(difference / tickSize);
        potentialGain = gainInTicks * tickValue;
      }

      if (Math.abs(difference) >= gapThreshold) {
        liquiditySweeps.push({
          time: currentCandle.time,
          breachLevel,
          reversalClose,
          direction: "bearish",
          difference,
          potentialGain,
        });
      }
    }
  }

  return { liquiditySweeps };
};
